import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
// import asyncComponent from './lib/AsyncComponent';
import Loadable from 'react-loadable';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import promise from 'redux-promise';
import reducers from './reducers/';
import './css/css-chart.css';

import Loader from './components/custom/Loader';
const PortalSignin = Loadable({
    loader: () => import('./components/Portal/PortalSignin'),
    loading() {
        return <Loader />
    }
});
const PortalChangePassword = Loadable({
    loader: () => import('./components/Portal/PortalChangePassword'),
    loading() {
        return <Loader />
    }
});
const PortalResetPassword = Loadable({
    loader: () => import('./components/Portal/PortalResetPassword'),
    loading() {
        return <Loader />
    }
});
const PortalForgotPassword = Loadable({
    loader: () => import('./components/Portal/PortalForgotPassword'),
    loading() {
        return <Loader />
    }
});
const PortalDashboard = Loadable({
    loader: () => import('./components/Portal/PortalDashboard'),
    loading() {
        return <Loader />
    }
});
const AffiliateSignup = Loadable({
    loader: () => import('./components/affiliate/AffiliateSignup'),
    loading() {
        return <Loader />
    }
});

const createStoreWithMiddleware = applyMiddleware(promise)(createStore);
const store = createStoreWithMiddleware(reducers,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

class PortalEntry extends Component {
    componentDidMount() {

    }
    render() {
        return (
            <Provider store={store}>
                <Router>
                    <div>
                        <div>
                            <Route exact path="/portal/signin/:portal_name" component={PortalSignin} />
                            <Route exact path="/portal/create/:portal_name" component={PortalChangePassword} />
                            <Route exact path="/affiliate/signup/:portal_name" component={AffiliateSignup} />
                            <Route exact path="/portal/reset/:portal_name" component={PortalResetPassword} />
                            <Route exact path="/portal/forgotpassword/:portal_name" component={PortalForgotPassword} />
                            <Route path="/portal/app/:ln/:portal_name" component={PortalDashboard} />
                        </div>
                    </div>
                </Router>
            </Provider>
        )
    }
}
export default PortalEntry;